<template>
  <div>
    <form @submit.prevent action>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Editar Informações do Sócio</p>
        </header>

        <section class="modal-card-body">
          <div class="tile is-ancestor">
            <div class="tile is-vertical">
              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Nome do Sócio">
                      <b-input
                        placeholder="Ex.: Rodolpho Abrantes Junior"
                        size="is-medium"
                        v-model="associado.nome"
                        required
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent is-3">
                  <article class="tile is-child">
                    <b-field label="Sexo">
                      <b-select v-model="associado.sexo" size="is-medium" required expanded>
                        <option>Feminino</option>
                        <option>Masculino</option>
                        <option>Não Informado</option>
                      </b-select>
                    </b-field>
                  </article>
                </div>
              </div>
              <!--tile-->
              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Data de Nascimento">
                      <b-input
                        placeholder="Ex.: 20/12/2012"
                        v-model="associado.nascimento.data"
                        size="is-medium"
                        v-mask="'##/##/####'"
                        required
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Estado de Nascimento">
                      <b-select v-model="associado.nascimento.estado" size="is-medium" required expanded>
                        <option
                        v-for="(estado, index) in estados_brasileiros"
                        :value="estado.nome"
                        :key="index">{{estado.nome}}</option>
                      </b-select>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Cidade de Nascimento">
                      <b-select v-model="associado.nascimento.cidade" size="is-medium" required expanded>
                        <option
                        v-for="(cidade, index) in cidades_brasileiras_nascimento"
                        :value="cidade"
                        :key="index">{{cidade}}</option>
                      </b-select>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Profissão Atual">
                      <b-input
                        placeholder="Ex.: Agricultor"
                        size="is-medium"
                        v-model="associado.profissao_atual"
                        required
                      ></b-input>
                    </b-field>
                  </article>
                </div>
              </div>
              <!--tile-->
              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="CPF">
                      <b-input
                        v-model="associado.cpf"
                        size="is-medium"
                        v-mask="'###.###.###-##'"
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Nº RG">
                      <b-input
                        placeholder="Ex.: 20081293489"
                        size="is-medium"
                        v-model="associado.rg.numero"
                        required
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Órgão Expeditor">
                      <b-input
                        placeholder="Ex.: SSP"
                        size="is-medium"
                        v-model="associado.rg.orgao_expeditor"
                        required
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Data de Expedição">
                      <b-input
                        placeholder="Ex.: 20/12/2012"
                        v-model="associado.rg.data_expedicao"
                        size="is-medium"
                        v-mask="'##/##/####'"
                        required
                      ></b-input>
                    </b-field>
                  </article>
                </div>
              </div>
              <!--tile-->
              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Logradouro">
                      <b-input
                        placeholder="Ex.: Rua João Sebastião"
                        size="is-medium"
                        v-model="associado.endereco.rua"
                        required
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Bairro">
                      <b-input
                        placeholder="Ex.: Bairro Jardim Azul"
                        size="is-medium"
                        v-model="associado.endereco.bairro"
                        required
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Número">
                      <b-input
                        placeholder="Ex.: 1090"
                        size="is-medium"
                        v-model="associado.endereco.numero"
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="CEP">
                      <b-input
                        placeholder="Ex.: 63000-090"
                        v-model="associado.endereco.cep"
                        size="is-medium"
                        v-mask="'#####-###'"
                        required
                      ></b-input>
                    </b-field>
                  </article>
                </div>
              </div>
              <!--tile-->
              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Estado">
                      <b-select v-model="associado.endereco.estado" size="is-medium" required expanded>
                        <option
                        v-for="(estado, index) in estados_brasileiros"
                        :value="estado.nome"
                        :key="index">{{estado.nome}}</option>
                      </b-select>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Cidade">
                      <b-select v-model="associado.endereco.cidade" size="is-medium" required expanded>
                        <option
                        v-for="(cidade, index) in cidades_brasileiras_residencia"
                        :value="cidade"
                        :key="index">{{cidade}}</option>
                      </b-select>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Tipo de Residência">
                      <b-select
                        v-model="associado.endereco.tipo_residencia"
                        size="is-medium"
                        required
                        expanded
                      >
                        <option>Própria</option>
                        <option>Alugada</option>
                        <option>Familiar</option>
                        <option>Cedida</option>
                      </b-select>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Estado Civil">
                      <b-select
                        class="b-select"
                        size="is-medium"
                        v-model="associado.estado_civil"
                        required
                        expanded
                      >
                        <option>Solteiro(a)</option>
                        <option>Casado(a)</option>
                        <option>Separado(a)</option>
                        <option>Divorciado(a)</option>
                        <option>Viúvo(a)</option>
                        <option>União Estável</option>
                        <option>Desquitado(a)</option>
                      </b-select>
                    </b-field>
                  </article>
                </div>
              </div>
              <!--tile-->
              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Telefone Celular">
                      <b-input
                        placeholder="Ex.: (00) 0 0000-0000"
                        v-model="associado.telefone_celular"
                        size="is-medium"
                        v-mask="'(##) # ####-####'"
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Telefone Fixo">
                      <b-input
                        placeholder="Ex.: (00) 0000-0000"
                        v-model="associado.telefone_fixo"
                        size="is-medium"
                        v-mask="'(##) ####-####'"
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Data de Ingresso">
                      <b-input
                        placeholder="Ex.: 12/01/2000"
                        v-model="associacao.data_ingresso"
                        size="is-medium"
                        required
                        v-mask="'##/##/####'"
                      ></b-input>
                    </b-field>
                  </article>
                </div>
              </div>
              <!--tile-->
            </div>
            <!--tile is-vertical-->
          </div>
          <!--tile is-ancestor-->
        </section>

        <footer class="modal-card-foot">
          <button class="button is-success" @click="subscribePartner">Salvar</button>
          <button class="button is-danger" @click="closeModal">Cancelar</button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import estadosCidades from '@/assets/files/estados_cidades'

export default {
  props: ["socio"],
  data() {
    return {
      estados_brasileiros: estadosCidades.estados,
      cidades_brasileiras_nascimento: estadosCidades.estados[5].cidades,
      cidades_brasileiras_residencia: estadosCidades.estados[5].cidades,
      associado: {
        _id: this.socio._id,
        nome: this.socio.nome,
        sexo: this.socio.sexo,
        nascimento: {
          cidade: '',
          estado: '',
          data: this.socio.nascimento.data
        },
        cpf: this.socio.cpf,
        rg: {
          numero: this.socio.rg.numero,
          orgao_expeditor: this.socio.rg.orgao_expeditor,
          data_expedicao: this.socio.rg.data_expedicao
        },
        profissao_atual: this.socio.profissao_atual,
        estado_civil: this.socio.estado_civil,
        endereco: {
          rua: this.socio.endereco.rua,
          bairro: this.socio.endereco.bairro,
          numero: this.socio.endereco.numero,
          cep: this.socio.endereco.cep,
          cidade: '',
          estado: '',
          tipo_residencia: this.socio.endereco.tipo_residencia
        },
        telefone_celular: this.socio.telefone_celular,
        telefone_fixo: this.socio.telefone_fixo,
      },
      associacao: this.socio.associacoes[`${this.$cookies.get("IDASSOCIACAO")}`]
    };
  },
  watch: {
    'associado.nascimento.estado': function () {
      this.cidades_brasileiras_nascimento = this.estados_brasileiros.filter((estado) => {
        return estado.nome === this.associado.nascimento.estado
      })[0].cidades
    },
    'associado.endereco.estado': function () {
      this.cidades_brasileiras_residencia = this.estados_brasileiros.filter((estado) => {
        return estado.nome === this.associado.endereco.estado
      })[0].cidades
    }
  },
  computed: {
    successAddPartner() {
      return this.$store.getters["associados/getIsSuccess"];
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    validateForm() {
      if (!this.associado.nome.trim()) return "Insira o Nome!";
      else if (!this.associado.sexo) return "Selecione o Sexo!";
      else if (!this.associado.nascimento.data) return "Selecione a Data de Nascimento!";
      else if (!this.associado.nascimento.estado) return "Selecione o Estado de Nascimento!";
      else if (!this.associado.nascimento.cidade) return "Selecione a Cidade de Nascimento!";
      else if (!this.associado.profissao_atual) return "Insira a Profissão Atual!";
      else if (!this.associado.rg.numero) return "Insira o Número do RG!";
      else if (!this.associado.rg.orgao_expeditor) return "Insira o Órgão Expeditor!";
      else if (!this.associado.rg.data_expedicao) return "Insira a Data de Expedição!";
      else if (!this.associado.endereco.rua.trim()) return "Insira o Logradouro!";
      else if (!this.associado.endereco.bairro.trim()) return "Insira o Bairro!";
      else if (!this.associado.endereco.cep) return "Insira o CEP!";
      else if (!this.associado.endereco.cidade) return "Selecione a Cidade!";
      else if (!this.associado.endereco.estado) return "Selecione o Estado!";
      else if (!this.associado.endereco.tipo_residencia) return "Selecione o Tipo de Resiência!";
      else if (!this.associado.estado_civil) return "Selecione o Estado Civil!";
      else if (!this.associacao.data_ingresso) return "Insira a Data de Ingresso!";
      return;
    },

    async subscribePartner() {
      const loadingComponent = this.$loading.open({
        container: null
      });

      let error = this.validateForm();
      if (error) {
        this.$alert("Aviso!", error, "danger");
        return;
      }
      // this.associado._id = this.stringRandomId(28);
      this.associado.cpf = this.associado.cpf.replace(/\D+/g, "");
      this.associado.associacoes = { [`${this.$cookies.get("IDASSOCIACAO")}`]: this.associacao }
      this.associacao.data_ingresso = this.transformDateToISOString(this.associacao.data_ingresso);
      this.associado.nascimento.data = this.transformDateToISOString(this.associado.nascimento.data);
      this.associado.rg.data_expedicao = this.transformDateToISOString(this.associado.rg.data_expedicao);

      console.log(this.associado);

      await this.$store.dispatch("associados/updateSocioInFirestore", this.associado);
      loadingComponent.close();

      if (this.successAddPartner) {
        this.$alert("Sucesso!", "Sócio Cadastrado!", "success");
        this.$store.commit("associados/setIsSuccess", false);
        this.closeModal();
      } else {
        this.$alert("Erro!", "Erro ao Atualizar Informações do Sócio!", "danger");
      }
      //Atualiza localmente os dados da associação
      this.$store.commit("associacao/setRequireUpdate", true);
      this.$store.dispatch("associacao/getAssociacaoInFirestore");
    },

    transformDateToISOString(oldDate) {
      let date = oldDate.split("/");
      return date[2]+"-"+date[1]+"-"+date[0]+"T03:00:00.000Z";
    },

    stringRandomId(tamanho) {
      let letras = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
      let aleatorio = "";
      for (var i = 0; i < tamanho; i++) {
        var rnum = Math.floor(Math.random() * letras.length);
        aleatorio += letras.substring(rnum, rnum + 1);
      }
      return aleatorio;
    }
  },
  mounted() {
    this.associacao.data_ingresso = new Date(this.associacao.data_ingresso).toLocaleDateString()
    this.associado.nascimento.data = new Date(this.associado.nascimento.data).toLocaleDateString()
    this.associado.rg.data_expedicao = new Date(this.associado.rg.data_expedicao).toLocaleDateString()

    this.associado.nascimento.estado = this.socio.nascimento.estado;
    this.associado.nascimento.cidade = this.socio.nascimento.cidade;
    this.associado.endereco.estado = this.socio.endereco.estado;
    this.associado.endereco.cidade = this.socio.endereco.cidade;
  },
};
</script>

<style scoped>
@media screen and (max-width: 1088px) {
  .modal .animation-content .modal-card {
    overflow: scroll !important;
  }
}
</style>